"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/features/array/includes");
require("core-js/features/promise");
exports.omit = function (ks, original) {
    return Object.keys(original)
        .filter(function (k) { return !ks.includes(k); })
        .reduce(function (filtered, k) {
        var _a;
        return Object.assign(original, (_a = {}, _a[k] = original[k], _a));
    }, {});
};
exports.retryTimes = function (n, fn) {
    return new Promise(function (resolve, reject) {
        return retry(n, fn)
            .then(function (result) { return resolve(result); })
            .catch(function (err) { return reject(err); });
    });
};
var retry = function (i, fn) {
    return fn().catch(function (err) {
        if (i <= 0)
            throw err;
        return retry(i - 1, fn);
    });
};
exports.generateRID = (function () {
    var rid = 1;
    return function () { return rid++ && String(rid); };
})();
//# sourceMappingURL=utils.js.map